import { format } from 'date-fns';

/**
 * Formats the staff-side `expiresOn` value for display.
 *
 * The provider endpoints return ISO datetimes (`expiresAt`), but the staff
 * endpoint's `expiresOn` is documented only as `string` with no format given, so
 * it may already be display-ready. Parse it when we can and fall back to the raw
 * value when we can't — that way an ISO datetime never leaks into prose as
 * "expires on 2026-08-15T00:00:00Z", and a pre-formatted string passes through
 * untouched.
 *
 * TODO: drop the fallback once the backend pins the format.
 */
export const formatInfoRequestDate = (value: string | null): string | null => {
	if (!value) return null;

	const parsed = new Date(value);
	if (Number.isNaN(parsed.getTime())) return value;

	return format(parsed, 'MMM d, yyyy');
};

export default formatInfoRequestDate;
